import script from "./SaveEventConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./SaveEventConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./SaveEventConfirmation.vue?vue&type=style&index=0&id=74e30094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e30094"]])

export default __exports__